import React from 'react';

import { Typography } from 'components/shared/Typography';

import { FormikField } from 'components/FormikField';

import { PropertySelectField } from '../PropertySelectField';

import styles from './SelectionProperty.module.scss';

const _renderProperty = () => (
  <Typography
    className={styles.label}
    variant="body2"
    weight="medium"
    mode="compact"
  >
    Selected:
  </Typography>
);

const SelectionProperty = ({
  isInitialState,
  readOnly,
  designType,
  namePrefix,
  property,
  onChanged,
}: {
  isInitialState: any;
  readOnly: any;
  designType: any;
  namePrefix: any;
  property: any;
  onChanged: any;
}) => {
  if (!property) {
    return null;
  }

  if (isInitialState || designType === 'PROTOTYPE') {
    return null;
  }

  return (
    <FormikField
      name={namePrefix}
      withControl={false}
      component={PropertySelectField}
      componentProps={{
        type: 'checkbox',
        readOnly,
        property,
        renderProperty: _renderProperty,
        onChanged,
      }}
    />
  );
};

export default React.memo(SelectionProperty) as any;
